// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".input-icon.search-input{width:100%}.input-icon.search-input .input.bottom-bordered{font-size:.9375rem;padding-left:1.5rem;padding-right:1.5rem}.input-icon.search-input button{align-items:center;display:flex}.input-icon.search-input button i.icon{height:1rem!important;position:static!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
